document.addEventListener("DOMContentLoaded", async () => {
  // ============================
  // DOM Elements and Global Variables
  // ============================
  const videoIntro = document.getElementById("videoIntro");
  const quizContainer = document.querySelector(".quiz-container");
  const progressBar = document.querySelector("#progressBar");
  const termsCheckbox = document.getElementById("terms-checkbox");
  const emailCheckbox = document.getElementById("email-checkbox");
  const submitButton = document.querySelector(".submit-btn");
  const restartButton = document.querySelector(".restart-btn");
  const phoneInput = document.querySelector(".phone-input");
  const emailInput = document.querySelector(".email-input");
  const firstNameInput = document.querySelector(".first-name-input");
  const lastNameInput = document.querySelector(".last-name-input");
  // const genderInput = document.querySelector(".gender-input");
  // const monthSelect = document.getElementById("month");
  // const yearSelect = document.getElementById("year");
  const sectionLabels = document.querySelectorAll(".section-label");

  const emailError = document.getElementById("emailError");
  const phoneError = document.getElementById("phoneError");

  // ===== Intro screen elements =====
  const introScreen = document.getElementById("quizIntro");
  const startQuizBtn = document.getElementById("startQuizBtn");
  const unlockBlueprintBtn = document.getElementById("unlockBlueprintBtn");
  const quizForm = document.getElementById("productQuiz");

  // Track whether we’ve loaded / started already
  let quizHasLoaded = false;
  let quizHasStarted = false;

  let currentQuestionIndex = 0;
  let questions = [];
  let sections = [];
  let historyStack = [];
  let selectedScores = {};
  let selectedAnswers = {};

  // Map abbreviations to full names
  const doshaMap = {
    P: "Pitta",
    VP: "Vata-Pitta",
    V: "Vata",
    K: "Kapha",
    PK: "Pitta-Kapha"
  };

  // Prepopulate email if passed in query params
  const urlParams = new URLSearchParams(window.location.search);
  // collect all utm parameters into a single object
  const utmParams = {};
  ["source", "medium", "campaign", "term", "content"].forEach((k) => {
    const v = urlParams.get(`utm_${k}`);
    if (v) utmParams[k] = v;
  });
  const utmSource = utmParams.source; // convenience alias used elsewhere
  console.log("utm params found:", utmParams);

  const emailFromQuery = urlParams.get("email");
  if (emailFromQuery) {
    emailInput.value = emailFromQuery;
  }

  function stopIntroVideo() {
  const video = document.getElementById("videoIntro");
  if (!video) return;

  const iframe = video.querySelector("iframe");

  if (iframe) {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }

  // extra safety: fully hide it
  video.style.display = "none";
}

  async function startQuiz() {
  stopIntroVideo();   // ✅ ADD THIS FIRST

  console.log("quiz Has Loaded:", quizHasLoaded);

  introScreen.classList.add("hidden");
  quizForm.classList.remove("hidden");
  quizContainer.classList.remove("hidden");

  if (!quizHasLoaded) {
    await loadQuestions();
    quizHasLoaded = true;
  }

  if (!quizHasStarted) {
    showQuestion(currentQuestionIndex);
    quizHasStarted = true;
  }
}

  //klaviyo logic
  async function subscribeToKlaviyo({
    publicApiKey,
    listId,
    email,
    firstName,
    lastName,
    klaviyoId,
    dosha,
    phone,
    utmSource,
    utmParams // new optional argument, may contain all UTM keys
  }) {
    // Build subscriptions object
    const subscriptions = {
      email: { marketing: { consent: "SUBSCRIBED" } },
    };
    if (phone) {
      subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };
    }
    // Build properties object
    const properties = { dosha };
    // include either single-source convenience, or any full params
    if (utmSource) {
      console.log("utmsource found:", utmSource);
      properties.utm_source = utmSource;
    }
    if (utmParams) {
      // merge additional utm fields (source may be repeated)
      Object.entries(utmParams).forEach(([k, v]) => {
        properties[`utm_${k}`] = v;
      });
    }
    // Build attributes object
    const attributes = {
      email,
      first_name: firstName,
      last_name: lastName,
      properties,
      subscriptions,
    };
    if (phone) {
      attributes.phone_number = phone;
    }
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              ...(klaviyoId ? { id: klaviyoId } : {}),
              attributes,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId,
            },
          },
        },
      },
    };

    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${publicApiKey}`,
        {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2025-04-15",
            "content-type": "application/vnd.api+json",
          },
          body: JSON.stringify(payload),
        }
      );
      const text = await res.text();
      const data = text ? JSON.parse(text) : {};
      console.log(data);
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function updateKlaviyoProfileProperties({
  publicApiKey,
  email,
  firstName,
  lastName,
  phone,
  dosha,
  recommendedToolkit,
  utmSource,
  utmParams
}) {
  const properties = {};

  // Use the exact same property names from your CSV import
  if (dosha) {
    properties["Dosha"] = dosha;
  }

  if (recommendedToolkit) {
    properties["Recommended Toolkit"] = recommendedToolkit;
  }

  if (utmSource) {
    properties["utm_source"] = utmSource;
  }

  if (utmParams) {
    Object.entries(utmParams).forEach(([k, v]) => {
      properties[`utm_${k}`] = v;
    });
  }

  const attributes = {
    email,
    first_name: firstName,
    last_name: lastName,
    properties
  };

  if (phone) {
    attributes.phone_number = phone;
  }

  const payload = {
    data: {
      type: "profile",
      attributes
    }
  };

  const res = await fetch(
    `https://a.klaviyo.com/client/profiles/?company_id=${publicApiKey}`,
    {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2025-04-15",
        "content-type": "application/vnd.api+json"
      },
      body: JSON.stringify(payload)
    }
  );

  const text = await res.text();
  const data = text ? JSON.parse(text) : {};

  if (!res.ok) {
    console.error("Klaviyo profile property update failed:", data);
    throw new Error("Klaviyo profile property update failed");
  }

  console.log("Klaviyo profile properties updated:", data);
  return data;
}

  // ============================
  // Load Questions from JSON
  // ============================
  async function loadQuestions() {
    try {
      const response = await fetch(jsonFileUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Loaded JSON data:", data);

      sections = data.sections; // Update global `sections`
      questions = data.questions; // Update global `questions`

      if (!sections || !Array.isArray(sections)) {
        throw new Error(
          "Sections data is missing or invalid in the JSON file."
        );
      }

      if (!questions || !Array.isArray(questions) || questions.length === 0) {
        throw new Error(
          "Questions data is missing or invalid in the JSON file."
        );
      }

      renderSections(sections);
      renderQuestions();
      showQuestion(0);
    } catch (error) {
      console.error("Error loading questions:", error);
    }
  }

  // ============================
  // Render Sections and Questions
  // ============================
  function renderSections(sections) {
    const progressText = document.querySelector(".progress-text");

    if (!Array.isArray(sections)) {
      console.error("Sections is not an array:", sections);
      return;
    }

    progressText.innerHTML = sections
      .map(
        (section, index) =>
          `<span class="section-label" id="section${index + 1}">${section.name
          }</span>`
      )
      .join("");
  }

  function renderQuestions() {
    const quizQuestions = document.getElementById("quizQuestions");
    quizQuestions.innerHTML = "";

    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }

    questions.forEach((question, index) => {
      const questionElement = document.createElement("div");
      questionElement.classList.add("question");

      // Mark the first question as active, hide the rest
      if (index === 0 || index === 2) {
        questionElement.classList.add("active");
      } else {
        questionElement.classList.add("hidden");
        question.options = shuffleArray(question.options);
      }

      // Determine input type: checkbox for the first question, radio for others
      const inputType = index === 0 ? "checkbox" : "radio";

      questionElement.innerHTML = `
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <h3>${question.question_text}</h3>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <p>${question.hint || ""}</p>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <div class="options">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ${question.options
          .map(
            (option) => `
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <label class="option-card">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              type="${inputType}"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                name="question${index}"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  value="${option.value}"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    ${selectedAnswers[index] &&
                (Array.isArray(selectedAnswers[index])
                  ? selectedAnswers[index].includes(option.value)
                  : selectedAnswers[index] === option.value)
                ? "checked"
                : ""
              }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      />
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <span class="option-text">${option.text}</span>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            </label>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    `
          )
          .join("")}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <div class="button-container">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <button type="button" class="prev-btn" ${index === 0 ? "disabled" : ""
        }>Previous</button>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      <button type="button" class="next-btn" disabled>Next</button>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <button type="button" class="restart-btn">Restart</button>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        `;

      quizQuestions.appendChild(questionElement);

      // Add event listener to enable the "Next" button when an option is selected
      const options = questionElement.querySelectorAll(
        `input[type='${inputType}']`
      );
      const nextButton = questionElement.querySelector(".next-btn");

      options.forEach((input) => {
        input.addEventListener("change", () => {
          if (index === 0) {
            const naOption = Array.from(options).find(
              (opt) => opt.value === "N/A"
            );

            if (input.value === "N/A") {
              if (input.checked) {
                // Uncheck all other options
                options.forEach((otherInput) => {
                  if (otherInput !== input) {
                    otherInput.checked = false;
                  }
                });
              }
            } else {
              // If any other option is selected, uncheck "N/A"
              if (naOption && naOption.checked) {
                naOption.checked = false;
              }
            }
          }

          // Enable the "Next" button if at least one option is selected
          const isAnyOptionSelected = Array.from(options).some(
            (input) => input.checked
          );
          nextButton.disabled = !isAnyOptionSelected;
        });
      });
    });

    console.log("Questions rendered successfully.");
  }

  // ============================
  // Visual logic
  // ============================

  function showQuestion(index) {
    const allQuestions = document.querySelectorAll(".question");

    if (!allQuestions || allQuestions.length === 0) {
      console.error("No questions found to display.");
      return;
    }

    allQuestions.forEach((question, i) => {
      if (i === index) {
        question.classList.add("active");
        question.classList.remove("hidden");

        // ✅ Check if any inputs are selected to enable Next button
        const inputs = question.querySelectorAll(
          "input[type='radio'], input[type='checkbox']"
        );
        const nextButton = question.querySelector(".next-btn");

        if (nextButton) {
          const isAnySelected = Array.from(inputs).some(
            (input) => input.checked
          );
          nextButton.disabled = !isAnySelected;
        }
      } else {
        question.classList.remove("active");
        question.classList.add("hidden");
      }
    });

    console.log(`Showing question at index: ${index}`);
    console.log("Selected answers so far:", selectedAnswers);

    updateProgress(index);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function updateProgress(index) {
    if (!questions || questions.length === 0) {
      console.error("Questions array is empty or undefined.");
      progressBar.value = 0; // Set progress to 0 if questions are not loaded
      return;
    }

    const progressValue = ((index + 1) / questions.length) * 100;
    progressBar.value = progressValue;

    sections.forEach((section, sectionIndex) => {
      const sectionLabel = document.getElementById(
        `section${sectionIndex + 1}`
      );
      if (index >= section.start && index <= section.end) {
        sectionLabel.classList.add("active");
      } else {
        sectionLabel.classList.remove("active");
      }
    });
  }

  // ============================
  // Navigation Logic
  // ============================

  // NEXT BTN
  quizContainer.addEventListener("click", (event) => {
    if (event.target.classList.contains("next-btn")) {
      const currentQuestion = questions[currentQuestionIndex];
      const selectedOptions = Array.from(
        quizContainer.querySelectorAll(
          `input[name="question${currentQuestionIndex}"]:checked`
        )
      ).map((input) => input.value);

      console.log(
        `Selected options for question ${currentQuestionIndex}:`,
        selectedOptions
      );
      console.log(
        `Scores for question ${currentQuestionIndex}:`,
        selectedScores[currentQuestionIndex]
      );

      if (selectedOptions.length > 0) {
        selectedAnswers[currentQuestionIndex] = selectedOptions;

        // Push the current question index onto the history stack
        historyStack.push(currentQuestionIndex);

        // Navigate to the next question
        currentQuestionIndex = getNextQuestion(
          currentQuestionIndex,
          selectedOptions
        );
        saveQuizProgress();
        showQuestion(currentQuestionIndex);
      }

      //console.log("Selected answers so far:", selectedAnswers);
      console.log("Selected scores so far:", selectedScores);
    }
  });

  //PREV BTN
  quizContainer.addEventListener("click", (event) => {
    if (event.target.classList.contains("prev-btn")) {
      if (historyStack.length > 0) {
        // Remove the selected answers and scores for the current question
        delete selectedAnswers[currentQuestionIndex];
        delete selectedScores[currentQuestionIndex];
        console.log(
          `Removed answers and scores for question ${currentQuestionIndex}`
        );
        console.log("Updated selectedAnswers:", selectedAnswers);
        console.log("Updated selectedScores:", selectedScores);

        // Pop the last visited question index from the history stack
        currentQuestionIndex = historyStack.pop();

        // Show the previous question
        saveQuizProgress();
        showQuestion(currentQuestionIndex);
      }
    }
  });

  //RESTART BTN
  document.addEventListener("click", (event) => {
    if (event.target.classList.contains("restart-btn")) {
      // Confirm with the user before restarting
      if (
        confirm(
          "Are you sure you want to restart the quiz? All progress will be lost."
        )
      ) {
        // Clear saved progress from localStorage
        localStorage.removeItem("quizProgress");

        // Reset global variables
        currentQuestionIndex = 0;
        selectedAnswers = {};
        selectedScores = {};
        historyStack = [];

        // Reset the progress bar
        const progressBar = document.getElementById("progressBar");
        if (progressBar) {
          progressBar.value = 0;
        }

        // Clear all selected inputs
        const inputs = document.querySelectorAll(
          "input[type='radio'], input[type='checkbox']"
        );
        inputs.forEach((input) => {
          input.checked = false; // Uncheck all inputs
          input.disabled = false; // Re-enable all inputs
        });

        // Disable all "Next" buttons
        const nextButtons = document.querySelectorAll(".next-btn");
        nextButtons.forEach((button) => {
          button.disabled = true; // Disable all "Next" buttons
        });

        // Show the first question
        introScreen.classList.remove("hidden");
        quizForm.classList.add("hidden");
        quizContainer.classList.add("hidden");

        quizHasStarted = false;

        console.log("Quiz restarted. All progress has been reset.");
      }
    }
  });

  // SUBMIT BTN
  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();

    // Disable the button and show the spinner
    submitButton.disabled = true;
    submitButton.querySelector(".button-text").textContent = "Submitting...";
    submitButton.querySelector(".loading-spinner").style.display =
      "inline-block";

    // Collect personal information
    const email = emailInput.value.trim();
    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    // const gender = genderInput.value;
    // const month = monthSelect.value;
    // const year = yearSelect.value;
    const countryCode = document.getElementById("country-code").value;
    const localPhone = phoneInput.value.trim().replace(/\D/g, ""); // remove non-digits

    let phone = "";
    if (localPhone) {
      phone = countryCode + localPhone;
    } // else phone stays as empty string

    // Prepare the request body
    const requestBody = {
      email,
      firstName,
      lastName,
      // gender,
      // birthMonth: month,
      // birthYear: year,
      phone: phone,
      responses: Object.keys(selectedAnswers)
        .filter((questionIndex) => questions[questionIndex])
        .map((questionIndex) => ({
          question: questions[questionIndex].question_text,
          answers: selectedAnswers[questionIndex],
          scores: selectedScores[questionIndex] || [],
        })),
      // send the full utm object so server can record all fields
      utm: utmParams
    };
    console.log("Submitting data:", requestBody); // Debugging: Log the request body

    try {
      const response = await fetch(
        "https://arvasi-testing.azurewebsites.net/submit-quiz",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (response.ok) {
        //alert("Survey submitted successfully!");
        document.getElementById("confirmationModal").classList.remove("hidden");

        const fullDosha = doshaMap[data.dosha] || data.dosha;
        document.getElementById("doshaText").textContent = fullDosha;
        document.getElementById("doshaButtonText").textContent = " " + fullDosha;

        localStorage.removeItem("quizProgress"); // Clear saved progress

        await subscribeToKlaviyo({
  publicApiKey: "UimHHD",
  listId: "URJdzQ",
  email,
  firstName,
  lastName,
  klaviyoId: data.klaviyoId,
  dosha: data.dosha,
  phone,
  utmSource,
  utmParams
});

await updateKlaviyoProfileProperties({
  publicApiKey: "UimHHD",
  email,
  firstName,
  lastName,
  phone,
  dosha: data.dosha,
  recommendedToolkit: data.recommendedToolkit,
  utmSource,
  utmParams
});

        // Wait for the user to close the modal before redirecting
        const modalCloseBtn = document.getElementById("modal-close-button");
        modalCloseBtn.addEventListener("click", () => {
          document.getElementById("confirmationModal").classList.add("hidden");
          console.log('Redirecting with:', data);
          window.location.href = `/pages/success?dosha=${encodeURIComponent(data.dosha)}&toolkit=${encodeURIComponent(data.recommendedToolkit)}`;
          //window.location.href = `/products/summer-2025-arvasi-box`;
        });
      } else if (response.status === 400 && data.createAccountUrl) {
        // Redirect to Shopify account creation page
        if (confirm(data.message)) {
          window.location.href = data.createAccountUrl;
        }
      } else {
        // Handle other error responses
        alert("Error submitting survey: " + data.message);
      }
    } catch (err) {
      console.error("Error submitting survey:", err);
      alert("Error submitting survey: " + err.message);
    } finally {
      // Reset the button state
      submitButton.disabled = false;
      submitButton.querySelector(".button-text").textContent = "Submit";
      submitButton.querySelector(".loading-spinner").style.display = "none";
    }
  });

  // ============================
  // Branching Logic
  // ============================
  // Determine the next question based on branching logic
  function getNextQuestion(currentIndex, selectedOptions) {
    const currentQuestion = questions[currentIndex];

    const branchingLogic = currentQuestion.options.find((option) =>
      selectedOptions.includes(option.value)
    )?.NextQuestion;

    if (branchingLogic !== undefined) {
      const nextIndex = questions.findIndex(
        (q) => q.question_id === branchingLogic
      );
      if (nextIndex !== -1) {
        return nextIndex;
      }
    }

    if (currentQuestion.Next_Question !== undefined) {
      const nextIndex = questions.findIndex(
        (q) => q.question_id === currentQuestion.Next_Question
      );
      if (nextIndex !== -1) {
        return nextIndex;
      }
    }

    return currentIndex + 1;
  }

  // ============================
  // Validation Code
  // ============================
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
    return emailRegex.test(email);
  }

  function validatePhoneNumber(phone) {
    // Remove all non-digit characters
    const cleanedPhone = phone.replace(/\D/g, "");

    // Validate that it's between 7 and 15 digits
    const phoneRegex = /^[0-9]{7,15}$/;
    return phoneRegex.test(cleanedPhone);
  }

  function validateForm() {
    let email = emailInput.value.trim();
    let firstName = firstNameInput.value.trim();
    let lastName = lastNameInput.value.trim();
    // let gender = genderInput.value;
    // let month = monthSelect.value;
    // let year = yearSelect.value;
    let phone = phoneInput.value.trim();
    let isTermsChecked = termsCheckbox.checked;
    let isEmailChecked = emailCheckbox.checked;

    let isPhoneValid = phone === "" || validatePhoneNumber(phone);
    let isValidEmail = validateEmail(email);

    if (isValidEmail) {
      emailError.classList.add("hidden");
    } else {
      emailError.classList.remove("hidden");
    }

    if (isPhoneValid) {
      phoneError.classList.add("hidden");
    } else {
      phoneError.classList.remove("hidden");
    }

    const isPersonalInfoValid =
      email !== "" &&
      isValidEmail &&
      firstName !== "" &&
      lastName !== "" &&
      // year !== "" &&
      isPhoneValid &&
      isEmailChecked &&
      isTermsChecked;

    submitButton.disabled = !isPersonalInfoValid;
    console.log("FormValidated:", isPersonalInfoValid);
  }

  // ============================
  // Save and Reload Quiz
  // ============================

  function saveQuizProgress() {
    const quizProgress = {
      email: emailInput.value.trim(),
      firstName: firstNameInput.value.trim(),
      lastName: lastNameInput.value.trim(),
      // gender: genderInput.value,
      // birthMonth: monthSelect.value,
      // birthYear: yearSelect.value,
      phone: phoneInput.value.trim(),
      selectedAnswers,
      selectedScores,
      currentQuestionIndex,
      historyStack,
    };

    localStorage.setItem("quizProgress", JSON.stringify(quizProgress));
  }

  function restoreQuizProgress() {
    const saved = localStorage.getItem("quizProgress");
    if (!saved) return; // nothing to restore

    const quizProgress = JSON.parse(saved);

    // Restore personal info...
    emailInput.value = quizProgress.email || "";
    firstNameInput.value = quizProgress.firstName || "";
    lastNameInput.value = quizProgress.lastName || "";
    phoneInput.value = quizProgress.phone || "";

    // Restore answers in DOM and in-memory
    Object.entries(quizProgress.selectedAnswers).forEach(([idx, opts]) => {
      selectedAnswers[idx] = opts;
      document
        .querySelectorAll(`input[name="question${idx}"]`)
        .forEach((input) => {
          if (opts.includes(input.value)) input.checked = true;
        });
    });

    // Restore scores & history
    Object.assign(selectedScores, quizProgress.selectedScores);
    historyStack = quizProgress.historyStack || [];

    // Restore the question index
    currentQuestionIndex = quizProgress.currentQuestionIndex || 0;
  }

  // ============================
  // Event Listeners
  // ============================

  startQuizBtn.addEventListener("click", startQuiz);
  unlockBlueprintBtn.addEventListener("click", startQuiz);

  [
    firstNameInput,
    lastNameInput,
    emailInput,
    phoneInput,
    termsCheckbox,
    emailCheckbox,
  ].forEach((input) => {
    input.addEventListener("input", validateForm);
  });

  emailInput.addEventListener("input", () => {
    validateForm();
    saveQuizProgress();
  });
  firstNameInput.addEventListener("input", () => {
    validateForm();
    saveQuizProgress();
  });
  lastNameInput.addEventListener("input", () => {
    validateForm();
    saveQuizProgress();
  });
  // genderInput.addEventListener("change", () => {
  //   validateForm();
  //   saveQuizProgress();
  // });
  // monthSelect.addEventListener("change", () => {
  //   validateForm();
  //   saveQuizProgress();
  // });
  // yearSelect.addEventListener("change", () => {
  //   validateForm();
  //   saveQuizProgress();
  // });
  phoneInput.addEventListener("input", () => {
    validateForm();
    saveQuizProgress();
  });
  termsCheckbox.addEventListener("change", () => {
    validateForm();
    saveQuizProgress();
  });
  emailCheckbox.addEventListener("change", () => {
    validateForm();
    saveQuizProgress();
  });

  quizContainer.addEventListener("change", () => {
    saveQuizProgress();
  });

  quizContainer.addEventListener("input", (event) => {
    if (event.target.matches("input[type='radio'], input[type='checkbox']")) {
      const questionIndex = parseInt(
        event.target.name.replace("question", ""),
        10
      );

      const selectedOptions = Array.from(
        quizContainer.querySelectorAll(
          `input[name="question${questionIndex}"]:checked`
        )
      );

      selectedAnswers[questionIndex] = selectedOptions.map(
        (input) => input.value
      );

      selectedScores[questionIndex] = selectedOptions
        .map((input) => {
          const option = questions[questionIndex].options.find(
            (opt) => opt.value === input.value
          );
          return option?.score || null;
        })
        .filter((score) => score !== null);

      console.log(
        `Updated selected answers for question ${questionIndex}:`,
        selectedAnswers[questionIndex]
      );
      console.log(
        `Updated scores for question ${questionIndex}:`,
        selectedScores[questionIndex]
      );
      console.log("Selected scores so far:", selectedScores);

      validateForm();
    }
  });

  // ============================
  // Fetch Questions and Restore Progress
  // ============================

  const savedProgress = localStorage.getItem("quizProgress");
  if (savedProgress) {
    restoreQuizProgress(); // 2️⃣ set index & check inputs
    startQuiz(); // 3️⃣ now reveal the quiz
  } else {
    introScreen.classList.remove("hidden");
    quizForm.classList.add("hidden");
    quizContainer.classList.add("hidden");
  }
});
